require("./gallery");

import "../../gallery/widget.scss";
import "../../gallery/gallery/gallery.scss";
import "../../gallery/popup/popup.scss";
